import angular from 'angular';

angular.module('cloudX').directive('cxEmployeeTagInputXedit', [
  '$filter',
  '$http',
  'appUrls',
  'checkSecurity',
  function($filter, $http, appUrls, checkSecurity) {
    return {
      restrict: 'E',
      template: `<div>
                  <div ng-if="readonly" ng-bind="displayValue"></div>
                  <form data-editable-form name="tagsForm" class="tagsForm" onbeforesave="beforeSave($data.tags)" ng-if="!readonly">
                    <div editable-tags-input="innerValue" data-e-form="tagsForm" data-e-name="tags" name="tags" e-replace-spaces-with-dashes="false" e-placeholder="{{('Add a tag'|translate)}}" e-min-length="1" e-add-from-autocomplete-only="{{!!disableCreate}}">
                      <a href="" ng-click="readValue(); tagsForm.$show();" ng-show="!tagsForm.$visible" title="{{('Edit tags'|translate)}}">
                        <span ng-show="displayValue">{{displayValue}}</span>
                        <i class="glyphicon glyphicon-pencil" ng-hide="displayValue"></i>
                      </a>
                      <editable-tags-input-auto-complete min-length="1" source="loadTags($query)" load-on-down-arrow="true" select-first-match="false"></editable-tags-input-auto-complete>
                    </div>
                    <div class="buttons">
                      <span ng-show="tagsForm.$visible">
                        <button type="submit" class="btn btn-inverse btn-xs" ng-disabled="tagsForm.$waiting" data-translate>Save</button>&nbsp;
                        <button type="button" class="btn btn-default btn-xs" ng-disabled="tagsForm.$waiting" ng-click="tagsForm.$cancel()" data-translate>Cancel</button>&nbsp;
                      </span>
                    </div>
                  </form>
                </div>`,
      scope: {
        value: '=data',
        save: '&',
        readonly: '=?',
        disableCreate: '=?',
      },
      link: function(scope) {
        scope.innerValue = [];
        scope.tags = null;
        scope.displayValue = '';
        scope.loadTags = function(search) {
          if (scope.tags !== null)
            return $filter('filter')(
              scope.tags.map(x => x.name),
              search,
            );
          if (checkSecurity('RegistrationOthers:r') || checkSecurity('Users:r'))
            return $http.get(appUrls.api + '/api/employee/tags').then(function({ data }) {
              scope.tags = data;
              return $filter('filter')(
                scope.tags.map(x => x.name),
                search,
              );
            });
        };

        scope.setDisplayValue = function(value) {
          if (typeof value === 'string') value = JSON.parse(value);
          scope.displayValue = (value || []).map(x => x.name).join(', ');
        };

        scope.readValue = function() {
          var value = scope.value;
          if (typeof value === 'string') value = JSON.parse(value);
          if (angular.isArray(value)) {
            scope.innerValue = value.map(function(el) {
              return {
                text: el.name,
              };
            });
          } else {
            scope.innerValue = [];
          }
        };
        scope.$watch(
          'value',
          function(newValue, oldValue) {
            scope.readValue();
            scope.setDisplayValue(newValue);
          },
          true, //Force equal check, doesn't work without it...
        );

        scope.beforeSave = function(data) {
          var tags = data.map(function(el) {
            return el.text;
          });
          return scope
            .save({
              $data: tags,
            })
            .then(
              result => {
                scope.value = result;
                scope.setDisplayValue(result);

                return false;
              },
              error => {
                return '';
              },
            );
        };
      },
    };
  },
]);
